import { Injectable } from '@angular/core';
import SafeUrlAssembler from 'safe-url-assembler';
import { HttpClientService } from '../../../core/services/http/http-client.service';
import { ApiEndpointService } from '../../../core/services/api-endpoint.service';
import { SSOToken } from '../../models/single-sign-on.model';

@Injectable()
export class SingleSignOnService {


  constructor(private httpClientService: HttpClientService, private apiEndpointService: ApiEndpointService) {

  }

  /**
   * Generate Zendesk SSO Token.
   *   
   * @returns {Observable<any>}
   */
  public generateSSOToken() {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('generateSingleSignOn'))
      .toString();

    return this.httpClientService.get<any>(endpoint);
  }

}
